/**
 =========================================================
 * Material Dashboard 2 React - v2.2.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-react
 * Copyright 2023 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

// Material Dashboard 2 React base styles
import colors from "assets/theme-dark/base/colors";
import boxShadows from "assets/theme-dark/base/boxShadows";
import borders from "assets/theme-dark/base/borders";
import rgba from "../../functions/rgba";

const { primary,background,secondary,text } = colors;
const { md } = boxShadows;
const { borderRadius } = borders;

const tablePagination = {
    styleOverrides: {
        root: {
            '.Mui-selected': {
                color: `white !important`,
            },
            '.MuiPaginationItem-text': {
                color: `white`,
            },
            '.MuiSelect-select': {
                color: `white`,
            },
        },

    },
};

export default tablePagination;
